<template>
  <ion-content id="app" class="ion-padding page-content">
    <ion-grid>
      <ion-row>
        <ion-col size="12" size-sm="6" offset-sm="3">
          <h1 class="ion-padding">Inhalt bearbeiten</h1>
          <ContentFields modus="edit" :id="id"/>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-content>
</template>

<script>
  import ContentFields from "../../components/content/ContentFields";

  export default {
    name: "ContentEdit",
    components: {ContentFields},
    data(){
      return {
        id: this.$route.params.id
      }
    },
  };
</script>

<style scoped>
  h1 {
    color: #B6B6B6;
  }

</style>
